import { tasksKeys, RequestTypes } from '@core/react-query/features/tasks/tasks'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ITaskDraft, TaskDraft } from '@core/entities/task/TaskDraft'

const dataTransformer = (response: PageResponse<ITaskDraft>) => {
  return {
    ...response,
    content: response.content.map((task) => TaskDraft.new(task)),
  }
}

export const useGetDraftTasks = (
  payload: RequestTypes['getDrafts'],
  options: UseQueryOptions<
    PageResponse<ITaskDraft>,
    RequestErrorType,
    PageResponse<TaskDraft>
  > = {},
) => {
  return useQuery({
    select: dataTransformer,
    ...tasksKeys.draftTasks(payload),
    keepPreviousData: true,
    ...options,
  })
}
